import SubscruptionSelector from './components/SubscruptionSelector';
import useAuth0 from './auth/useAuth0';
import { createTheme, ThemeProvider } from '@mui/material/styles';
import LanguageSelector from './components/LanguageSelector';
import { useTranslation } from 'react-i18next';

// eslint-disable-next-line
import i18n from './i18n';
import InfoBox from './components/InfoBox';
import { useEffect, useState } from 'react';

const theme = createTheme({
  palette: {
    primary: {
      main: '#00bcd4'
    }
  }
});

const App = () => {
  const { t, i18n } = useTranslation();
  const { subscriptions, tryRedirect } = useAuth0(i18n.language);

  const [error, setError] = useState();

  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    setError(params?.get('error'));
  }, []);

  return (
    <ThemeProvider theme={theme}>
      <div className="page-container">
        <div className="d-flex justify-content-between">
          <div className="logo"></div>
          <LanguageSelector selectedLanguage={i18n.language} setLanguage={e => i18n.changeLanguage(e.target.value)} />
        </div>

        <div className="content row justify-content-center align-items-center">
          <div style={{ width: '450px' }}>
            <div className="mb-2">
              {error && (
                <InfoBox type="error" closeable={false}>
                  <div className="ml-2">{t(error)}</div>
                </InfoBox>
              )}
            </div>
            {subscriptions ? (
              <SubscruptionSelector subscriptions={subscriptions} subscriptionSelected={tryRedirect} />
            ) : (
              <div id="auth0_login" className="auth-login"></div>
            )}
          </div>
        </div>
      </div>
    </ThemeProvider>
  );
};

export default App;
